import { getISOWeek } from 'date-fns';
import { parseDate, formatDate } from '../../../../../utils/dateUtils';
import { TFunction } from 'i18next';
import { WorkloadType } from '../../../__generated__/graphql';

export const getTimeSheetTitle = (
  t: TFunction,
  startDate: string,
  workloadType: string,
) => {
  if (workloadType === WorkloadType.Weekly) {
    const parsedDate = parseDate(startDate);
    return t('calendarWeek', {
      week: getISOWeek(parsedDate),
    });
  } else {
    return formatDate(startDate, 'LLLL');
  }
};
